import { render, staticRenderFns } from "./StudentRow.vue?vue&type=template&id=3d2abc9d&scoped=true&"
import script from "./StudentRow.vue?vue&type=script&lang=js&"
export * from "./StudentRow.vue?vue&type=script&lang=js&"
import style0 from "./StudentRow.vue?vue&type=style&index=0&id=3d2abc9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2abc9d",
  null
  
)

export default component.exports